<template>
  <div>
    <div
      v-if="networkInterfaces.length > 0"
      class="d-flex align-items-center mb-2"
    >
      <label
        class="mr-1"
        for="networkInterface"
      >Network Interface</label>
      <v-select
        v-model="networkInterface"
        class="flex-fill distro-single-select"
        :options="networkInterfaces"
        placeholder="Select Network Interface"
      />
    </div>
    <network-chart :device-id="networkInterface" />
  </div>
</template>
<script>
import NetworkChart from './charts/NetworkChart.vue'
import vSelect from 'vue-select'

export default {
  name: 'HostDetailsNetwrok',
  components: { NetworkChart, vSelect },
  props: {
    host: {
      type: Object,
      required: true,
    },
  },
  computed: {
    networkInterface: {
      get() {
        return this.$store.state.observability.networkInterface
      },
      set(val) {
        this.$store.commit(
          'observability/SET_NETWORK_INTERFACE',
          val !== null ? val : this.networkInterface,
        )
      },
    },
    networkInterfaces() {
      return this.$store.state.observability.networkInterfaces
    },
  },
}
</script>
<style lang="scss" scoped>
.analytics-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 385px;
}
.interface {
  max-width: 200px;
}
.distro-single-select {
  max-width: 200px;
  height: 34px;

  ::v-deep {
    .vs__clear {
      display: none;
    }
  }
}
</style>
